import { render } from "./AddQuestionQCM.vue?vue&type=template&id=1b24b122&scoped=true&ts=true"
import script from "./AddQuestionQCM.vue?vue&type=script&lang=ts"
export * from "./AddQuestionQCM.vue?vue&type=script&lang=ts"

import "./AddQuestionQCM.vue?vue&type=style&index=0&id=1b24b122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b24b122"]])

export default __exports__